module.exports = __webpack_public_path__ + "assets/images/project/icon/yr_icon.svg?v=bc2e99ec";